import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Grid, Typography } from '@coursera/cds-core';
import { StyleSheet, css } from '@coursera/coursera-ui';

import PrimaryButtonContentful from 'bundles/coursera-plus-landing-page/components/ctaContentful/PrimaryButtonContentful';
import { CTA_LOCATIONS, PRESENTATIONS } from 'bundles/coursera-plus-landing-page/contentful/constants';
import { logo } from 'bundles/coursera-plus/utils/courseraPlusUtils';
import { BASE_STYLES } from 'bundles/design-system/components/container-styles';

import _t from 'i18n!nls/coursera-plus-landing-page';

const LOGO_WIDTH = 206;

const styles = StyleSheet.create({
  container: {
    margin: '0 auto',
    ...BASE_STYLES.container,
  },
  desktopCta: {
    fontSize: '14px !important',
    lineHeight: '14px !important',
    padding: '17px 13px !important',
  },
  headlineWrapper: {
    padding: '0 20px',
    textAlign: 'center',
    display: 'block',
    margin: '0 auto',
  },
  ctaWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '16px',
  },
});

type Props = {
  bannerText: string;
  isCourseraLiteContentfulPage: boolean;
};

const StickyContentDesktop: React.FC<Props> = (props) => (
  <Grid className={css(styles.container).className}>
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item lg={3} sm={3}>
        {props.isCourseraLiteContentfulPage ? (
          <Imgix src={logo.LITE_FULL_BLUE_HD} alt={_t('Coursera Lite')} maxWidth={LOGO_WIDTH} maxHeight={20} />
        ) : (
          <Imgix src={logo.PLUS_FULL_BLUE} alt={_t('Coursera Plus')} maxWidth={LOGO_WIDTH} maxHeight={20} />
        )}
      </Grid>
      <Grid item lg={6} sm={4}>
        <Typography variant="h3bold" component="span" {...css(styles.headlineWrapper)}>
          {props.bannerText}
        </Typography>
      </Grid>
      <Grid item lg={3} sm={3} {...css(styles.ctaWrapper)}>
        <PrimaryButtonContentful
          ctaLocation={CTA_LOCATIONS.sticky}
          presentation={PRESENTATIONS.smallButton}
          rootClassName={css(styles.desktopCta).className}
          isFirstCheckoutInHero={false}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default StickyContentDesktop;
